import axios from 'axios'
import router from '@/router'

export const callApi = async (method, endpoint, data, overriddenHeaders, overriddenBody) => {
  const url = process.env.VUE_APP_API_URL + endpoint

  let headers = {
    'Content-Type': 'application/json'
  }

  if (overriddenHeaders) {
    headers = overriddenHeaders
  }

  const request = {
    method,
    url: url,
    headers: headers,
    cache: 'no-cache'
  }

  if (localStorage.getItem('token')) {
    // If we have an authorization token. put it in headers
        request.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
    }

  if (data) {
    request.data = data
  }
  if(overriddenBody) {
    request.data = overriddenBody
}

  return await axios(request)
    .then((response) => {
      if (response.status === 401 || response.data.status === 401) {
        localStorage.clear()
        router.push({ name: 'HomeView' })
      }
      return response
    })
    .catch((error) => {
      if (error.response.status === 401 || error.response.data.status === 401) {
        localStorage.clear()
        router.push({ name: 'HomeView' })
      }
      return error
    })
}
